import { api, API_BASE, getToken } from "./apiClient";

export const fileUrl = (path) => {
  if (!path) return null;
  const t = getToken();
  return `${API_BASE}/files/${path}${t ? `?auth=${encodeURIComponent(t)}` : ""}`;
};

export const LAYOUTS = [
  { value: 1, label: "1 per page" },
  { value: 2, label: "2 per page" },
  { value: 4, label: "4 per page" },
  { value: 6, label: "6 per page" },
];

export const DEPT_STATUS = {
  not_started: { label: "Not Started", cls: "border-cmdBorder text-zinc-500" },
  in_progress: { label: "In Progress", cls: "border-warnAmber text-warnAmber bg-warnAmber/5" },
  submitted: { label: "Submitted for Review", cls: "border-sky-500 text-sky-600 bg-sky-50" },
  approved: { label: "Approved", cls: "border-readyGreen text-readyGreen bg-readyGreen/5" },
};

export const deptPath = (dept) => `/post-event-report/dept/${encodeURIComponent(dept)}`;

export async function downloadVersion(version, format) {
  const res = await fetch(`${API_BASE}/report-versions/${version.id}/download?format=${format}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
    credentials: "include",
  });
  if (!res.ok) throw new Error("Download failed");
  const blob = await res.blob();
  const cd = res.headers.get("Content-Disposition") || "";
  const name = (cd.match(/filename="([^"]+)"/) || [])[1] || `Post_Event_Report_v${version.version}.${format}`;
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}

export const uploadFile = (url, file, field = "file") => {
  const fd = new FormData();
  fd.append(field, file, file.name || "photo.jpg");
  return api.post(url, fd);
};

export const errMsg = (e, fallback = "Something went wrong") => e?.response?.data?.detail || fallback;
